module.exports = __webpack_public_path__ + "img/my-object.3793bfc6.png";